(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-4-slide-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  // Initialize Swiper
  new Swiper(".video-slider", {
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: { slidesPerView: 4 },
      480: { slidesPerView: 2 },
      0: { slidesPerView: 1 },
    }
  });

  // Modal Elements
  const modal = document.getElementById("videoModal");
  const videoPlayer = document.getElementById("videoPlayer");
  const closeBtn = modal.querySelector(".close-modal");

  // Open modal on thumbnail click
  document.querySelectorAll(".video-thumbnail").forEach(img => {
    img.addEventListener("click", function () {
      const videoUrl = this.dataset.videoUrl;
      if (videoUrl) {
        videoPlayer.src = videoUrl;
        modal.classList.add("active");
      }
    });
  });

  // Close modal
  closeBtn.addEventListener("click", function () {
    modal.classList.remove("active");
    videoPlayer.pause();
    videoPlayer.currentTime = 0;
    videoPlayer.src = "";
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  // Initialize Swiper
  new Swiper(".video-slider", {
    slidesPerView: "auto",
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: { slidesPerView: 5 },
      480: { slidesPerView: 2 },
      0: { slidesPerView: 1 },
    }
  });

  // Video modal elements
  const videoModal = document.getElementById("videoModal");
  const videoPlayer = document.getElementById("videoPlayer");
  const videoCloseBtn = videoModal.querySelector(".close-modal");

  // Image modal elements
  const imageModal = document.getElementById("imageModal");
  const imageViewer = document.getElementById("imageViewer");
  const imageCloseBtn = imageModal.querySelector(".close-modal");

  // Thumbnail click
 document.querySelectorAll(".media-thumbnail").forEach(img => {
  img.addEventListener("click", function () {
    const videoUrl = this.dataset.videoUrl;
    const imageUrl = this.dataset.imageUrl;

    if (videoUrl) {
      videoPlayer.src = videoUrl;
      videoModal.classList.add("active");
    } else if (imageUrl) {
      imageViewer.src = imageUrl;
      imageModal.classList.add("active");
    }
  });
});


  // Close video modal
  videoCloseBtn.addEventListener("click", function () {
    videoModal.classList.remove("active");
    videoPlayer.pause();
    videoPlayer.currentTime = 0;
    videoPlayer.src = "";
  });

  // Close image modal
  imageCloseBtn.addEventListener("click", function () {
    imageModal.classList.remove("active");
    imageViewer.src = "";
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  // Initialize Swiper
  new Swiper(".video-slider", {
    slidesPerView: "auto",
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: { slidesPerView: 4 },
      480: { slidesPerView: 2 },
      0: { slidesPerView: 1 },
    }
  });

  // Video modal elements
  const videoModal = document.getElementById("videoModal");
  const videoPlayer = document.getElementById("videoPlayer");
  const videoCloseBtn = videoModal.querySelector(".close-modal");

  // Image modal elements
  const imageModal = document.getElementById("imageModal");
  const imageViewer = document.getElementById("imageViewer");
  const imageCloseBtn = imageModal.querySelector(".close-modal");

  // Thumbnail click
 document.querySelectorAll(".media-thumbnail").forEach(img => {
  img.addEventListener("click", function () {
    const videoUrl = this.dataset.videoUrl;
    const imageUrl = this.dataset.imageUrl;

    if (videoUrl) {
      videoPlayer.src = videoUrl;
      videoModal.classList.add("active");
    } else if (imageUrl) {
      imageViewer.src = imageUrl;
      imageModal.classList.add("active");
    }
  });
});


  // Close video modal
  videoCloseBtn.addEventListener("click", function () {
    videoModal.classList.remove("active");
    videoPlayer.pause();
    videoPlayer.currentTime = 0;
    videoPlayer.src = "";
  });

  // Close image modal
  imageCloseBtn.addEventListener("click", function () {
    imageModal.classList.remove("active");
    imageViewer.src = "";
  });
});

  } catch(e) { console.error(e); }
})();
})();
